import { ChangeDetectorRef, Component, HostBinding, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { EventTypes, ToastEvent, ToastService } from 'src/app/services/toast.service';
import { NgbToast } from '@ng-bootstrap/ng-bootstrap/toast';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-toast-container',
  templateUrl: './toast-container.component.html',
  styleUrls: ['./toast-container.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgbToast, NgClass],
})
export class ToastContainerComponent implements OnInit {
  private toastService = inject(ToastService);
  private cdr = inject(ChangeDetectorRef);

  @HostBinding('class')
  class = 'ngb-toasts';

  title: string = new Date().getTime().toString();
  body: string = new Date().getTime().toString();

  currentToasts: ToastEvent[] = [];

  EventTypes = EventTypes;

  ngOnInit() {
    this.subscribeToToasts();
  }

  subscribeToToasts() {
    this.toastService.toastEvents.subscribe(toasts => {
      const currentToast: ToastEvent = {
        type: toasts.type,
        message: toasts.message,
        autohide: toasts.autohide,
        delay: toasts.delay,
      };
      this.currentToasts.push(currentToast);
      this.cdr.detectChanges();
    });
  }

  dispose(index: number) {
    this.currentToasts.splice(index, 1);
    this.cdr.detectChanges();
  }
}
